import { UUID } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const GET_ASSET_THUMBNAIL_QUERY_KEY = 'assets.getAssetThumbnail';

export const useGetAssetThumbnail = ({ assetId, assetTenantId }: { assetId: UUID; assetTenantId?: UUID }) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const {
    data: thumbnail,
    isLoading,
    error,
  } = useQuery({
    queryKey: [GET_ASSET_THUMBNAIL_QUERY_KEY, { assetId: assetId }],
    queryFn: async () => {
      const { data, status, headers } = await api.assets.assetThumbnail(assetTenantId ?? tenantId, assetId);

      if (status !== 200) {
        throw new Error('Failed to download thumbnail');
      }

      return URL.createObjectURL(new Blob([data], { type: headers['content-type'] }));
    },
    enabled: !!assetId && !!tenantId,
    refetchOnMount: false,
    retry: false,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });

  return { thumbnail, isLoading, error };
};
